import store from '../configureStore';

import {
  plugin,
  config,
  zone,
  education
} from '../redux/actions';
import { setHelpItems } from '../pages/HelpScreens/redux/actions';
import sortHelpExtraConfig from './sortHelpExtraConfig';

const { dispatch } = store.store;

const { setStoreDistricts } = plugin;

const {
  setDistrictId,
  setLocalityId,
  setReminderOption,
} = config;

const {
  setPrompts,
  setCoordinate,
  setMapCityName,
  setExampleAddress,
  setGoogleSearchTerm,
} = zone;

const { setEducationData } = education;

const detectHelpItemRoute = ({
  type, custom_message: customMsg, title, extra_config
}, oidx) => {
  if (customMsg) return ({ path: '/help/description-page', params: { customMsg } });

  switch (type.toLowerCase()) {
    case 'missed_pickup':
      return {
        path: '/help/confirm-location',
        params: { prevRoute: '/help', extra_config }
      };

    case 'damaged_cart':
      return {
        path: extra_config ? '/help/damaged-cart' : '/help/form-page',
        params: extra_config ? { extra_config, oidx } : { title, type }
      };

    case 'reminder_problem':
      return { path: '/help/contact-us', params: { title, type, extra_config } };

    case 'other':
      return { path: '/help/other-problems', params: { extra_config } };

    default:
      return { path: '/help/form-page', params: { title, type, extra_config } };
  }
};

const checkItemShouldDisplay = (type, problems, hasCalendar) => {
  switch (type.toLowerCase()) {
    case 'missed_pickup':
      return hasCalendar;

    case 'other':
      return problems.filter(({ display_opt }) => display_opt !== 'P').length > 0;

    default:
      return true;
  }
};

const setDistrictsArray = (districts, selectedDistrict, hasCalendar) => {
  dispatch(setStoreDistricts(districts));
  if (selectedDistrict && selectedDistrict !== '-') {
    dispatch(setEducationData(districts[selectedDistrict].education_tab_elements));
    dispatch(setPrompts(districts[selectedDistrict].prompts));
    dispatch(setDistrictId(districts[selectedDistrict].district_id));
    dispatch(setMapCityName(districts[selectedDistrict].map_city_nm));
    dispatch(setLocalityId(districts[selectedDistrict].cms_locality_id));
    dispatch(setExampleAddress(districts[selectedDistrict].example_address));
    dispatch(setReminderOption(districts[selectedDistrict].reminder_option));

    if (
      districts[selectedDistrict].map_city_nm
      && districts[selectedDistrict].map_city_nm.google_search_term
    ) {
      dispatch(setGoogleSearchTerm(
        districts[selectedDistrict].map_city_nm.google_search_term
      ));
    }

    /**
     * Set the right format of lat & long coordinates
     */
    let lat = null;
    let lng = null;
    const { geo_point } = districts[selectedDistrict];
    if (geo_point) {
      const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

      if (geo_point.match(format)) {
        let changedCoordinate = geo_point.replace(/[&/\\#+()$~%'":*?<>{}]/g, '');
        changedCoordinate = changedCoordinate.split(',');
        [lat, lng] = changedCoordinate;
      }
    }
    dispatch(setCoordinate({ lat: Number(lat), lng: Number(lng) }));

    /**
     * Set the right format of help items
     */
    dispatch(
      setHelpItems(
        [...districts[selectedDistrict].help_items]
          .map((({ oidx, ...rest }) => {
            const isOther = rest.type.toLowerCase() === 'other';
            return ({
              route: detectHelpItemRoute(rest, oidx),
              oidx: (isOther)
                ? districts[selectedDistrict].help_items.length + 5
                : oidx,
              shouldDisplay: checkItemShouldDisplay(
                rest.type,
                // Maybe we can remove this in future?!
                districts[selectedDistrict].problem_types,
                hasCalendar
              ),
              ...rest,
              ...(rest.type === 'DAMAGED_CART') && ({ extra_config: sortHelpExtraConfig(rest?.extra_config) }),
            });
          }))
          .sort((a, b) => a.oidx - b.oidx)
      )
    );

    return districts[selectedDistrict].district_id;
  }

  return undefined;
};

export default setDistrictsArray;
